import { demoDoors, demoModules, demoRoom, demoWindows } from '@/Constants/demo';
import { storeConfigurationState } from '@/Interfaces/common';
import packageJson from '../../package.json';

export const configurationStoreDefaultState: storeConfigurationState = {
    room: {
        ...demoRoom,
        selectedRoomType: null,
        selectedWallCategory: null,
        selectedFloorCategory: null,
        selectedWallColor: null,
        selectedFloorColor: null,
    },
    wardrobeBaseColor: '#ffffff',
    wardrobe: {
        modules: demoModules,
        windows: demoWindows,
        doors: demoDoors,
        boxes: [],
        shelves: [],
        rails: [],
        version: packageJson.version,
    },
    projectName:'Новый проект',
    projectId: null,
    version: packageJson.version,
};


export const demoConfiguration = {
    'room': {
    'height': 2.7,
        'leftWallWidth': 3,
        'rightWallWidth': 3,
        'frontWallWidth': 3,
        'backWallWidth': 0,
        'selectedRoomType': 'dressingroom',
        'selectedWallCategory': 63,
        'selectedFloorCategory': 61,
        'selectedWallColor': 304,
        'selectedFloorColor': 294,
},
    'wardrobeBaseColor': '#ffffff',
    'wardrobe': {
        'modules': [
        {
            'uuid': '56d05477-ab05-4cc1-bb9b-1f8438b9bd93',
            'templates': {
                'rail': {
                    'id': 91,
                    'name': 'gr_65',
                    'url': null,
                    'blender_name': 'gr_65',
                    'image': '/upload/iblock/da5/sgtoobhvhcrjhtllz70ys1ut5stetb6x.jpg',
                    'priview': '/upload/iblock/18f/kadaq9koozyod3u776iqmmqkjiz5qqw5.jpg',
                    'height': 0.048,
                    'width': 0.65,
                    'depth': 0.009,
                    'scale': null,
                    'color': 'ffffff',
                    'sort': 100,
                    'shelfPosition': null,
                    'rodHolderPosition': null,
                    'childPosition': null,
                    'compatibilityWidth': '60',
                    'compatibilityDepth': null,
                    'price': 0,
                },
                'rack': {
                    'id': 100,
                    'name': 'gs_50',
                    'url': null,
                    'blender_name': 'gs_50',
                    'image': '/upload/iblock/e77/6ftjx0glopeo9c1tgn4ao5kfiypgxbqs.jpg',
                    'priview': '/upload/iblock/805/c3ry1imbkfj0v5xw17wdkwllcvn9zsbe.jpg',
                    'height': 0.507,
                    'width': 0.025,
                    'depth': 0.025,
                    'scale': null,
                    'color': 'ffffff',
                    'sort': 10,
                    'shelfPosition': null,
                    'rodHolderPosition': null,
                    'childPosition': null,
                    'compatibilityWidth': null,
                    'compatibilityDepth': null,
                    'price': 0,
                },
            },
            'width': 0.6,
            'height': 0.507,
            'depth': 0.305,
            'position': [
                0.5915679507375372,
                2.223804234949502,
                0.015,
            ],
            'railAlign': 'center',
            'side': 'front',
            'color': 'ffffff',
            'children': [
                {
                    'uuid': '6363601a-b1b1-45c8-877e-8a95f7931b58',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                        },
                        'shelfBracketRight': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                        },
                        'shelf': {
                            'id': 72,
                            'name': 'shelf_600_300',
                            'url': null,
                            'blender_name': 'shelf_600_300',
                            'image': '/upload/iblock/3e8/z7g3e5icg8qcvn61c1h6dynuxumlap1o.jpg',
                            'priview': '/upload/iblock/9a0/l6y1j7pvixc9ccrogkasekyaphie2fy3.jpg',
                            'height': 0.014,
                            'width': 0.607,
                            'depth': 0.305,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '30',
                            'price': 0,
                        },
                        'assets': [],
                    },
                    'height': 0.055,
                    'width': 0.6,
                    'depth': 0.3,
                    'humanName': 'Полка сетчатая GSh 60х30 белая',
                    'rodAvailable': true,
                },
                {
                    'uuid': '55c03480-addf-412b-ae48-5613501b59f9',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 6,
                        },
                        'shelfBracketRight': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 6,
                        },
                        'shelf': {
                            'id': 72,
                            'name': 'shelf_600_300',
                            'url': null,
                            'blender_name': 'shelf_600_300',
                            'image': '/upload/iblock/3e8/z7g3e5icg8qcvn61c1h6dynuxumlap1o.jpg',
                            'priview': '/upload/iblock/9a0/l6y1j7pvixc9ccrogkasekyaphie2fy3.jpg',
                            'height': 0.014,
                            'width': 0.607,
                            'depth': 0.305,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 3,
                        },
                        'assets': [],
                        'rod': {
                            'id': 113,
                            'name': 'rod_640',
                            'url': null,
                            'blender_name': 'rod_640',
                            'image': '/upload/iblock/de2/fe4m8srqylbsgl8dnuu27ksl8aea48fr.jpg',
                            'priview': '/upload/iblock/e90/t5351ouh513vs92yifcul7frwgo9bcwv.jpg',
                            'height': 0.025,
                            'width': 0.64,
                            'depth': 0.025,
                            'scale': null,
                            'color': '',
                            'sort': 20,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': null,
                            'price': 0,
                        },
                        'rodHolder': {
                            'id': 36,
                            'name': 'grb',
                            'url': null,
                            'blender_name': 'grb',
                            'image': '/upload/iblock/6eb/epflvd614qlk7xbcauxihhmkwgoubk85.jpg',
                            'priview': '/upload/iblock/1b0/pgtnn0005d23rh5dr5gos33kbixagz30.jpg',
                            'height': 0.1,
                            'width': 0.03,
                            'depth': 0.03,
                            'rotation': [
                                90,
                                0,
                                90,
                            ],
                            'offsets': [
                                0,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 70,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': [
                                0,
                                -0.081,
                                0,
                            ],
                            'compatibilityWidth': null,
                            'compatibilityDepth': null,
                            'price': 0,
                        },
                        'rodCapLeft': {
                            'name': 'grc_left',
                            'height': 0.1,
                            'width': 0.1,
                            'depth': 0.1,
                        },
                        'rodCapRight': {
                            'name': 'grc_right',
                            'height': 0.1,
                            'width': 0.1,
                            'depth': 0.1,
                        },
                    },
                    'width': 0.6,
                    'height': 0.055,
                    'depth': 0.3,
                    'type': 'shelf',
                    'place': 10,
                    'humanName': 'Полка сетчатая GSh 60х30 белая',
                    'rodAvailable': true,
                },
                {
                    'uuid': '2aa3d40b-1173-4a10-a337-37c15b4de0d3',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 4,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 4,
                        },
                        'pullOutFrame': {
                            'id': 318,
                            'name': 'sliding_frame_60',
                            'url': null,
                            'blender_name': 'sliding_frame_60',
                            'image': '',
                            'priview': '',
                            'height': 0.023,
                            'width': 0.595,
                            'depth': 0.427,
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.975,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 90,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 2,
                        },
                        'basket': {
                            'id': 6,
                            'name': 'gbm_600_400_285',
                            'url': null,
                            'blender_name': 'gbm_600_400_285',
                            'image': '/upload/iblock/41e/eh4i593hyq43j3j9t3ocrascc0lt8us3.jpg',
                            'priview': '/upload/iblock/bc7/78okni6kkxyuwlocqjnd9agv1glfhu07.jpg',
                            'height': 0.285,
                            'width': 0.578,
                            'depth': 0.423,
                            'rotation': [
                                0,
                                0,
                                180,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 60,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                        },
                        'assets': [],
                    },
                    'height': 0.285,
                    'width': 0.6,
                    'depth': 0.4,
                    'humanName': 'Корзина мелкосетчатая GBM 60х30 белая',
                    'rodAvailable': false,
                    'place': 48,
                },
                {
                    'uuid': '4a82bf58-ea4f-45b3-b5bd-b025b3193d65',
                    'type': 'panel',
                    'templates': {
                        'panel': {
                            'id': 49,
                            'name': 'gp_60_40',
                            'url': null,
                            'blender_name': 'gp_60_40',
                            'image': '/upload/iblock/810/i2bh65gv9nnsv99dtp0hbfz9d89lg3ka.jpg',
                            'priview': '/upload/iblock/f39/i8fpgee0p4ycp11izt6z7cs7wqdb9aaa.jpg',
                            'height': 0.382,
                            'width': 0.598,
                            'depth': 0.018,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 20,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': null,
                            'price': 0,
                        },
                        'assets': [],
                    },
                    'height': 0.382,
                    'width': 0.598,
                    'depth': 0.018,
                    'humanName': 'Перфопанель GP 60х40 белая',
                    'rodAvailable': false,
                    'place': 29,
                },
                {
                    'uuid': 'b9766c8f-bd15-437f-92aa-7a72e09f0145',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                        },
                        'pullOutFrame': {
                            'id': 318,
                            'name': 'sliding_frame_60',
                            'url': null,
                            'blender_name': 'sliding_frame_60',
                            'image': '',
                            'priview': '',
                            'height': 0.023,
                            'width': 0.595,
                            'depth': 0.427,
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.975,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 90,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                        },
                        'basket': {
                            'id': 4,
                            'name': 'gbm_600_400_85',
                            'url': null,
                            'blender_name': 'gbm_600_400_85',
                            'image': '/upload/iblock/480/7x1ri8rrs5z2u1u87a86x5jn69jgoxo2.jpg',
                            'priview': '/upload/iblock/066/5sw238bu7c2ud78n34lf5w5njbvn8eq1.jpg',
                            'height': 0.085,
                            'width': 0.578,
                            'depth': 0.423,
                            'rotation': [
                                0,
                                0,
                                180,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                        },
                        'assets': [],
                    },
                    'width': 0.6,
                    'height': 0.085,
                    'depth': 0.4,
                    'type': 'shelf',
                    'place': 44,
                    'humanName': 'Корзина мелкосетчатая GBM 60х10 белая',
                    'rodAvailable': false,
                },
            ],
            'needUpdate': true,
        },
        {
            'uuid': 'ee680398-fb79-413c-b7a1-7ea52a0296af',
            'templates': {
                'rail': {
                    'id': 91,
                    'name': 'gr_65',
                    'url': null,
                    'blender_name': 'gr_65',
                    'image': '/upload/iblock/da5/sgtoobhvhcrjhtllz70ys1ut5stetb6x.jpg',
                    'priview': '/upload/iblock/18f/kadaq9koozyod3u776iqmmqkjiz5qqw5.jpg',
                    'height': 0.048,
                    'width': 0.65,
                    'depth': 0.009,
                    'scale': null,
                    'color': 'ffffff',
                    'sort': 100,
                    'shelfPosition': null,
                    'rodHolderPosition': null,
                    'childPosition': null,
                    'compatibilityWidth': '60',
                    'compatibilityDepth': null,
                    'price': 0,
                    'count': 1,
                },
                'rack': {
                    'id': 100,
                    'name': 'gs_50',
                    'url': null,
                    'blender_name': 'gs_50',
                    'image': '/upload/iblock/e77/6ftjx0glopeo9c1tgn4ao5kfiypgxbqs.jpg',
                    'priview': '/upload/iblock/805/c3ry1imbkfj0v5xw17wdkwllcvn9zsbe.jpg',
                    'height': 0.507,
                    'width': 0.025,
                    'depth': 0.025,
                    'scale': null,
                    'color': 'ffffff',
                    'sort': 10,
                    'shelfPosition': null,
                    'rodHolderPosition': null,
                    'childPosition': null,
                    'compatibilityWidth': null,
                    'compatibilityDepth': null,
                    'price': 0,
                    'count': 1,
                },
            },
            'width': 0.6,
            'height': 0.507,
            'depth': 0.305,
            'position': [
                1.1983679507375373,
                2.223804234949502,
                0.015,
            ],
            'railAlign': 'center',
            'side': 'front',
            'color': 'ffffff',
            'children': [
                {
                    'uuid': 'bae64954-77b2-4ab0-a76c-27b6aac7e8d0',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 2,
                        },
                        'shelfBracketRight': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 2,
                        },
                        'shelf': {
                            'id': 72,
                            'name': 'shelf_600_300',
                            'url': null,
                            'blender_name': 'shelf_600_300',
                            'image': '/upload/iblock/3e8/z7g3e5icg8qcvn61c1h6dynuxumlap1o.jpg',
                            'priview': '/upload/iblock/9a0/l6y1j7pvixc9ccrogkasekyaphie2fy3.jpg',
                            'height': 0.014,
                            'width': 0.607,
                            'depth': 0.305,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 1,
                        },
                        'assets': [],
                    },
                    'height': 0.055,
                    'width': 0.6,
                    'depth': 0.3,
                    'humanName': 'Полка сетчатая GSh 60х30 белая',
                    'rodAvailable': true,
                },
                {
                    'uuid': '6bb89b5c-0d3c-41b1-afea-98f484d2a2cd',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 8,
                        },
                        'shelfBracketRight': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 8,
                        },
                        'shelf': {
                            'id': 72,
                            'name': 'shelf_600_300',
                            'url': null,
                            'blender_name': 'shelf_600_300',
                            'image': '/upload/iblock/3e8/z7g3e5icg8qcvn61c1h6dynuxumlap1o.jpg',
                            'priview': '/upload/iblock/9a0/l6y1j7pvixc9ccrogkasekyaphie2fy3.jpg',
                            'height': 0.014,
                            'width': 0.607,
                            'depth': 0.305,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 4,
                        },
                        'assets': [],
                        'rod': {
                            'id': 113,
                            'name': 'rod_640',
                            'url': null,
                            'blender_name': 'rod_640',
                            'image': '/upload/iblock/de2/fe4m8srqylbsgl8dnuu27ksl8aea48fr.jpg',
                            'priview': '/upload/iblock/e90/t5351ouh513vs92yifcul7frwgo9bcwv.jpg',
                            'height': 0.025,
                            'width': 0.64,
                            'depth': 0.025,
                            'scale': null,
                            'color': '',
                            'sort': 20,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': null,
                            'price': 0,
                            'count': 1,
                        },
                        'rodHolder': {
                            'id': 36,
                            'name': 'grb',
                            'url': null,
                            'blender_name': 'grb',
                            'image': '/upload/iblock/6eb/epflvd614qlk7xbcauxihhmkwgoubk85.jpg',
                            'priview': '/upload/iblock/1b0/pgtnn0005d23rh5dr5gos33kbixagz30.jpg',
                            'height': 0.1,
                            'width': 0.03,
                            'depth': 0.03,
                            'rotation': [
                                90,
                                0,
                                90,
                            ],
                            'offsets': [
                                0,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 70,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': [
                                0,
                                -0.081,
                                0,
                            ],
                            'compatibilityWidth': null,
                            'compatibilityDepth': null,
                            'price': 0,
                            'count': 1,
                        },
                        'rodCapLeft': {
                            'name': 'grc_left',
                            'height': 0.1,
                            'width': 0.1,
                            'depth': 0.1,
                        },
                        'rodCapRight': {
                            'name': 'grc_right',
                            'height': 0.1,
                            'width': 0.1,
                            'depth': 0.1,
                        },
                    },
                    'width': 0.6,
                    'height': 0.055,
                    'depth': 0.3,
                    'type': 'shelf',
                    'place': 10,
                    'humanName': 'Полка сетчатая GSh 60х30 белая',
                    'rodAvailable': true,
                },
                {
                    'uuid': 'ead1030d-8aae-40e7-adc1-81fd0818a732',
                    'type': 'panel',
                    'templates': {
                        'panel': {
                            'id': 49,
                            'name': 'gp_60_40',
                            'url': null,
                            'blender_name': 'gp_60_40',
                            'image': '/upload/iblock/810/i2bh65gv9nnsv99dtp0hbfz9d89lg3ka.jpg',
                            'priview': '/upload/iblock/f39/i8fpgee0p4ycp11izt6z7cs7wqdb9aaa.jpg',
                            'height': 0.382,
                            'width': 0.598,
                            'depth': 0.018,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 20,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': null,
                            'price': 0,
                            'count': 1,
                        },
                        'assets': [],
                    },
                    'height': 0.382,
                    'width': 0.598,
                    'depth': 0.018,
                    'humanName': 'Перфопанель GP 60х40 белая',
                    'rodAvailable': false,
                    'place': 29,
                },
                {
                    'uuid': 'c012008e-7907-4daa-86da-2cf461614f8c',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 12,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 12,
                        },
                        'shelf': {
                            'id': 214,
                            'name': 'gov_60',
                            'url': null,
                            'blender_name': 'gov_60',
                            'image': '/upload/iblock/fa8/zzis803jgyihsirl4vi0ya8s1vy574z2.jpg',
                            'priview': '/upload/iblock/b6d/1n3ytw3bhom3ox3uc84rn8y9u9fdujyz.jpg',
                            'height': 0.091,
                            'width': 0.595,
                            'depth': 0.427,
                            'rotation': [
                                0,
                                0,
                                0,
                            ],
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.974,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                        },
                        'assets': [],
                    },
                    'height': 0.091,
                    'width': 0.6,
                    'depth': 0.4,
                    'humanName': 'Обувница GOV-60 белая',
                    'rodAvailable': false,
                    'place': 44,
                },
                {
                    'uuid': 'ac97027e-6f13-4bd1-a098-36bc5058b549',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 14,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 14,
                        },
                        'shelf': {
                            'id': 214,
                            'name': 'gov_60',
                            'url': null,
                            'blender_name': 'gov_60',
                            'image': '/upload/iblock/fa8/zzis803jgyihsirl4vi0ya8s1vy574z2.jpg',
                            'priview': '/upload/iblock/b6d/1n3ytw3bhom3ox3uc84rn8y9u9fdujyz.jpg',
                            'height': 0.091,
                            'width': 0.595,
                            'depth': 0.427,
                            'rotation': [
                                0,
                                0,
                                0,
                            ],
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.974,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 1,
                        },
                        'assets': [],
                    },
                    'height': 0.091,
                    'width': 0.6,
                    'depth': 0.4,
                    'humanName': 'Обувница GOV-60 белая',
                    'rodAvailable': false,
                    'place': 50,
                },
                {
                    'uuid': 'f4fcbcf6-d1dc-4544-b7ad-228b4e03dfb7',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 16,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 16,
                        },
                        'shelf': {
                            'id': 214,
                            'name': 'gov_60',
                            'url': null,
                            'blender_name': 'gov_60',
                            'image': '/upload/iblock/fa8/zzis803jgyihsirl4vi0ya8s1vy574z2.jpg',
                            'priview': '/upload/iblock/b6d/1n3ytw3bhom3ox3uc84rn8y9u9fdujyz.jpg',
                            'height': 0.091,
                            'width': 0.595,
                            'depth': 0.427,
                            'rotation': [
                                0,
                                0,
                                0,
                            ],
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.974,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 2,
                        },
                        'assets': [],
                    },
                    'width': 0.6,
                    'height': 0.091,
                    'depth': 0.4,
                    'type': 'shelf',
                    'place': 56,
                    'humanName': 'Обувница GOV-60 белая',
                    'rodAvailable': false,
                },
            ],
            'needUpdate': true,
        },
        {
            'uuid': 'f2723756-4b13-412c-9394-c99091bb2623',
            'templates': {
                'rail': {
                    'id': 91,
                    'name': 'gr_65',
                    'url': null,
                    'blender_name': 'gr_65',
                    'image': '/upload/iblock/da5/sgtoobhvhcrjhtllz70ys1ut5stetb6x.jpg',
                    'priview': '/upload/iblock/18f/kadaq9koozyod3u776iqmmqkjiz5qqw5.jpg',
                    'height': 0.048,
                    'width': 0.65,
                    'depth': 0.009,
                    'scale': null,
                    'color': 'ffffff',
                    'sort': 100,
                    'shelfPosition': null,
                    'rodHolderPosition': null,
                    'childPosition': null,
                    'compatibilityWidth': '60',
                    'compatibilityDepth': null,
                    'price': 0,
                    'count': 2,
                },
                'rack': {
                    'id': 100,
                    'name': 'gs_50',
                    'url': null,
                    'blender_name': 'gs_50',
                    'image': '/upload/iblock/e77/6ftjx0glopeo9c1tgn4ao5kfiypgxbqs.jpg',
                    'priview': '/upload/iblock/805/c3ry1imbkfj0v5xw17wdkwllcvn9zsbe.jpg',
                    'height': 0.507,
                    'width': 0.025,
                    'depth': 0.025,
                    'scale': null,
                    'color': 'ffffff',
                    'sort': 10,
                    'shelfPosition': null,
                    'rodHolderPosition': null,
                    'childPosition': null,
                    'compatibilityWidth': null,
                    'compatibilityDepth': null,
                    'price': 0,
                    'count': 2,
                },
            },
            'width': 0.6,
            'height': 0.507,
            'depth': 0.305,
            'position': [
                1.8051679507375373,
                2.223804234949502,
                0.015,
            ],
            'railAlign': 'center',
            'side': 'front',
            'color': 'ffffff',
            'children': [
                {
                    'uuid': 'c97e4ec6-2cb9-462e-b8cd-0b45774a5777',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 4,
                        },
                        'shelfBracketRight': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 4,
                        },
                        'shelf': {
                            'id': 72,
                            'name': 'shelf_600_300',
                            'url': null,
                            'blender_name': 'shelf_600_300',
                            'image': '/upload/iblock/3e8/z7g3e5icg8qcvn61c1h6dynuxumlap1o.jpg',
                            'priview': '/upload/iblock/9a0/l6y1j7pvixc9ccrogkasekyaphie2fy3.jpg',
                            'height': 0.014,
                            'width': 0.607,
                            'depth': 0.305,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 2,
                        },
                        'assets': [],
                    },
                    'height': 0.055,
                    'width': 0.6,
                    'depth': 0.3,
                    'humanName': 'Полка сетчатая GSh 60х30 белая',
                    'rodAvailable': true,
                },
                {
                    'uuid': '1b1b3778-9f59-459b-aa74-4b05e0bc0ac2',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 10,
                        },
                        'shelfBracketRight': {
                            'id': 30,
                            'name': 'gbr_30',
                            'url': null,
                            'blender_name': 'gbr_30',
                            'image': '/upload/iblock/7d5/k0efdvrr47ufcz4zew73l7p5gmzywhbg.jpg',
                            'priview': '/upload/iblock/0fe/pgr6b6eggu29ke0f6nl5xbik4lpofcvu.jpg',
                            'height': 0.055,
                            'width': 0.012,
                            'depth': 0.335,
                            'rotation': [
                                -7.0086,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 100,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 10,
                        },
                        'shelf': {
                            'id': 72,
                            'name': 'shelf_600_300',
                            'url': null,
                            'blender_name': 'shelf_600_300',
                            'image': '/upload/iblock/3e8/z7g3e5icg8qcvn61c1h6dynuxumlap1o.jpg',
                            'priview': '/upload/iblock/9a0/l6y1j7pvixc9ccrogkasekyaphie2fy3.jpg',
                            'height': 0.014,
                            'width': 0.607,
                            'depth': 0.305,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '30',
                            'price': 0,
                            'count': 5,
                        },
                        'assets': [],
                        'rod': {
                            'id': 113,
                            'name': 'rod_640',
                            'url': null,
                            'blender_name': 'rod_640',
                            'image': '/upload/iblock/de2/fe4m8srqylbsgl8dnuu27ksl8aea48fr.jpg',
                            'priview': '/upload/iblock/e90/t5351ouh513vs92yifcul7frwgo9bcwv.jpg',
                            'height': 0.025,
                            'width': 0.64,
                            'depth': 0.025,
                            'scale': null,
                            'color': '',
                            'sort': 20,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': null,
                            'price': 0,
                            'count': 2,
                        },
                        'rodHolder': {
                            'id': 36,
                            'name': 'grb',
                            'url': null,
                            'blender_name': 'grb',
                            'image': '/upload/iblock/6eb/epflvd614qlk7xbcauxihhmkwgoubk85.jpg',
                            'priview': '/upload/iblock/1b0/pgtnn0005d23rh5dr5gos33kbixagz30.jpg',
                            'height': 0.1,
                            'width': 0.03,
                            'depth': 0.03,
                            'rotation': [
                                90,
                                0,
                                90,
                            ],
                            'offsets': [
                                0,
                                0,
                                0,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 70,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': [
                                0,
                                -0.081,
                                0,
                            ],
                            'compatibilityWidth': null,
                            'compatibilityDepth': null,
                            'price': 0,
                            'count': 2,
                        },
                        'rodCapLeft': {
                            'name': 'grc_left',
                            'height': 0.1,
                            'width': 0.1,
                            'depth': 0.1,
                        },
                        'rodCapRight': {
                            'name': 'grc_right',
                            'height': 0.1,
                            'width': 0.1,
                            'depth': 0.1,
                        },
                    },
                    'width': 0.6,
                    'height': 0.055,
                    'depth': 0.3,
                    'type': 'shelf',
                    'place': 10,
                    'humanName': 'Полка сетчатая GSh 60х30 белая',
                    'rodAvailable': true,
                },
                {
                    'uuid': '4b9ec5cf-ca25-457b-a6ab-3316d218a0c8',
                    'type': 'shelf',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 6,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 6,
                        },
                        'pullOutFrame': {
                            'id': 318,
                            'name': 'sliding_frame_60',
                            'url': null,
                            'blender_name': 'sliding_frame_60',
                            'image': '',
                            'priview': '',
                            'height': 0.023,
                            'width': 0.595,
                            'depth': 0.427,
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.975,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 90,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 3,
                        },
                        'basket': {
                            'id': 6,
                            'name': 'gbm_600_400_285',
                            'url': null,
                            'blender_name': 'gbm_600_400_285',
                            'image': '/upload/iblock/41e/eh4i593hyq43j3j9t3ocrascc0lt8us3.jpg',
                            'priview': '/upload/iblock/bc7/78okni6kkxyuwlocqjnd9agv1glfhu07.jpg',
                            'height': 0.285,
                            'width': 0.578,
                            'depth': 0.423,
                            'rotation': [
                                0,
                                0,
                                180,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 60,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 1,
                        },
                        'assets': [],
                    },
                    'height': 0.285,
                    'width': 0.6,
                    'depth': 0.4,
                    'humanName': 'Корзина мелкосетчатая GBM 60х30 белая',
                    'rodAvailable': false,
                    'place': 48,
                },
                {
                    'uuid': '52f02e3b-0a55-4ca4-b685-e3df0e20c1f5',
                    'templates': {
                        'panel': {
                            'id': 49,
                            'name': 'gp_60_40',
                            'url': null,
                            'blender_name': 'gp_60_40',
                            'image': '/upload/iblock/810/i2bh65gv9nnsv99dtp0hbfz9d89lg3ka.jpg',
                            'priview': '/upload/iblock/f39/i8fpgee0p4ycp11izt6z7cs7wqdb9aaa.jpg',
                            'height': 0.382,
                            'width': 0.598,
                            'depth': 0.018,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 20,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': null,
                            'price': 0,
                            'count': 2,
                        },
                        'assets': [],
                    },
                    'width': 0.598,
                    'height': 0.382,
                    'depth': 0.018,
                    'type': 'panel',
                    'place': 29,
                    'humanName': 'Перфопанель GP 60х40 белая',
                },
                {
                    'uuid': '67e6c71d-810f-4ca6-880a-b57d569297ca',
                    'templates': {
                        'shelfBracketLeft': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 2,
                        },
                        'shelfBracketRight': {
                            'id': 31,
                            'name': 'gbr_40',
                            'url': null,
                            'blender_name': 'gbr_40',
                            'image': '/upload/iblock/e2e/8f9l25cbn8vnf5rxlhoqrhckckp3pb6c.jpg',
                            'priview': '/upload/iblock/9fa/k9cbxi9pfipqzv77evff38ie3e8y39u7.jpg',
                            'height': 0.07,
                            'width': 0.012,
                            'depth': 0.435,
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 110,
                            'shelfPosition': [
                                0,
                                -0.002,
                                0.01,
                            ],
                            'rodHolderPosition': [
                                0,
                                -0.008,
                                0.267,
                            ],
                            'childPosition': null,
                            'compatibilityWidth': null,
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 2,
                        },
                        'pullOutFrame': {
                            'id': 318,
                            'name': 'sliding_frame_60',
                            'url': null,
                            'blender_name': 'sliding_frame_60',
                            'image': '',
                            'priview': '',
                            'height': 0.023,
                            'width': 0.595,
                            'depth': 0.427,
                            'offsets': [
                                0,
                                -0.012,
                                -0.002,
                            ],
                            'scale': [
                                0.975,
                                1,
                                0.99,
                            ],
                            'color': 'ffffff',
                            'sort': 90,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 1,
                        },
                        'basket': {
                            'id': 4,
                            'name': 'gbm_600_400_85',
                            'url': null,
                            'blender_name': 'gbm_600_400_85',
                            'image': '/upload/iblock/480/7x1ri8rrs5z2u1u87a86x5jn69jgoxo2.jpg',
                            'priview': '/upload/iblock/066/5sw238bu7c2ud78n34lf5w5njbvn8eq1.jpg',
                            'height': 0.085,
                            'width': 0.578,
                            'depth': 0.423,
                            'rotation': [
                                0,
                                0,
                                180,
                            ],
                            'scale': null,
                            'color': 'ffffff',
                            'sort': 40,
                            'shelfPosition': null,
                            'rodHolderPosition': null,
                            'childPosition': null,
                            'compatibilityWidth': '60',
                            'compatibilityDepth': '40',
                            'price': 0,
                            'count': 1,
                        },
                        'assets': [],
                    },
                    'width': 0.6,
                    'height': 0.085,
                    'depth': 0.4,
                    'type': 'shelf',
                    'place': 44,
                    'humanName': 'Корзина мелкосетчатая GBM 60х10 белая',
                    'rodAvailable': false,
                },
            ],
            'needUpdate': true,
        },
    ],
        'windows': [],
        'doors': [],
    },
};
